/*
 * OWL - Actualizacion en vivo de la barra de envio gratis.
 * El HTML inicial viene del servidor (snippets/owl-free-shipping-bar.liquid) y
 * los re-renders del carrito de Savor lo refrescan solos; este script da la
 * actualizacion INMEDIATA al agregar/quitar/cambiar cantidades, escuchando el
 * evento estandar del tema y consultando /cart.js. Escribe en el DOM solo
 * cuando el valor cambia (no pelear con el morph, ver leccion de owl-cart-terms).
 */
(() => {
  const formatCop = (cents) => '$' + Math.max(0, Math.round(cents / 100)).toLocaleString('es-CO');

  // Celebracion al CRUZAR el umbral en vivo (no en cargas de pagina):
  // confeti parabolico OWL disparado desde la barra + brillo sobre la barra
  // + toast con resorte y check que se dibuja. Una vez por pagina, sin
  // bloquear input (pointer-events none) y sin robar foco.
  let celebrated = false;
  let lastRemaining = null;

  // OWL 2026-07-17 (v3): verdes de la celebracion + negro, con un toque de rojo de
  // marca. Se evita el blanco puro: el carrito es blanco y el confeti se perdia.
  const CONFETTI_COLORS = ['#22c55e', '#111111', '#4ade80', '#15803d', '#ee171b'];

  const hasDiscount = (cart) => {
    const cartDiscounts = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    const itemDiscounts = Array.isArray(cart.items)
      && cart.items.some((item) => [
        item.discount_allocations,
        item.line_level_discount_allocations,
        item.discounts,
      ].some((allocations) => Array.isArray(allocations) && allocations.length > 0));

    return cartDiscounts.length > 0 || itemDiscounts;
  };

  const celebrate = () => {
    if (celebrated) return;
    celebrated = true;
    // Limpia cualquier celebracion anterior aun en pantalla, para poder volver a
    // dispararla apenas se cruce el umbral de nuevo (sin esperar a que caduque).
    document.querySelectorAll('.owl-fsb-party').forEach((el) => el.remove());

    const bar = document.querySelector('[data-owl-fsb]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const party = document.createElement('div');
    party.className = 'owl-fsb-party' + (reduced ? ' owl-fsb-party--static' : '');
    party.innerHTML =
      '<div class="owl-fsb-party__toast" role="status" aria-live="polite">' +
      '<span class="owl-fsb-party__check" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      '<span>¡Desbloqueaste el <strong>ENVÍO GRATIS</strong>!</span>' +
      '</div>';

    if (!reduced) {
      // Origen del confeti: la barra visible (el ojo del usuario esta ahi);
      // si no esta en pantalla, estalla desde el tercio inferior centrado.
      const rect = bar && bar.getBoundingClientRect();
      const visible = rect && rect.top > 0 && rect.bottom < window.innerHeight && rect.width > 0;
      const originY = visible ? rect.top + rect.height / 2 : window.innerHeight * 0.72;
      const originX0 = visible ? rect.left + 8 : window.innerWidth * 0.32;
      const originX1 = visible ? rect.right - 8 : window.innerWidth * 0.68;

      for (let i = 0; i < 34; i++) {
        const x = originX0 + Math.random() * (originX1 - originX0);
        const rise = 90 + Math.random() * 170;
        const size = 5 + Math.random() * 6;
        const outer = document.createElement('span');
        outer.className = 'owl-fsb-party__cx';
        outer.style.cssText =
          'left:' + x.toFixed(0) + 'px;top:' + originY.toFixed(0) + 'px;' +
          '--dx:' + ((Math.random() - 0.5) * 220).toFixed(0) + 'px;' +
          '--dur:' + (1.4 + Math.random() * 0.9).toFixed(2) + 's;' +
          '--delay:' + (Math.random() * 0.22).toFixed(2) + 's;';
        const inner = document.createElement('span');
        inner.className = 'owl-fsb-party__cy' + (Math.random() < 0.35 ? ' owl-fsb-party__cy--dot' : '');
        inner.style.cssText =
          'width:' + size.toFixed(1) + 'px;height:' + (size * (0.65 + Math.random() * 0.8)).toFixed(1) + 'px;' +
          'background:' + CONFETTI_COLORS[i % CONFETTI_COLORS.length] + ';' +
          '--rise:-' + rise.toFixed(0) + 'px;' +
          '--fall:' + (rise + 180 + Math.random() * 220).toFixed(0) + 'px;' +
          '--rot:' + ((Math.random() - 0.5) * 840).toFixed(0) + 'deg;';
        outer.appendChild(inner);
        party.appendChild(outer);
      }

      // La barra tambien celebra: brillo que la recorre + brinquito del badge
      if (bar) {
        bar.classList.add('owl-fsb--party');
        setTimeout(() => bar.classList.remove('owl-fsb--party'), 1600);
      }
    }

    document.body.appendChild(party);
    setTimeout(() => party.remove(), reduced ? 3200 : 3800);
  };

  const applyCart = (cart) => {
    document.querySelectorAll('[data-owl-fsb]').forEach((bar) => {
      const threshold = Number(bar.dataset.owlFsbThreshold) || 0;
      if (!threshold) return;

      const total = Number(cart.total_price) || 0;
      const remaining = threshold - total;
      // El envio gratis SI combina con descuentos de producto desde el
      // 2026-09-02. Antes no, y por eso aqui se apagaba el "logrado" y se
      // mostraba el aviso de "no aplica con descuentos" en cuanto habia uno.
      //
      // Con el 20% de toda la tienda ese aviso salia SIEMPRE: le decia al
      // cliente que no tenia envio gratis justo cuando si lo tenia, y la
      // barra nunca se ponia verde.
      //
      // Si algun dia se vuelve a cerrar `combinesWith.productDiscounts` en el
      // descuento `ENVIO GRATIS +$400.000`, hay que devolver las dos lineas
      // de abajo a como estaban:
      //     const discounted = hasAppliedDiscount && total >= threshold;
      //     const done = !hasAppliedDiscount && remaining <= 0;
      const discounted = false;
      const done = remaining <= 0;
      const pct = Math.max(4, Math.min(100, (total / threshold) * 100));

      // Re-armar: si el carrito vuelve a estar BAJO el umbral, la proxima vez que
      // se cruce debe celebrar de nuevo (antes 'celebrated' quedaba en true para
      // siempre y la animacion solo salia una vez por carga de pagina).
      if (!done) celebrated = false;

      // Cruce del umbral EN VIVO (antes faltaba, ahora no) -> celebrar
      if (!discounted && lastRemaining !== null && lastRemaining > 0 && done) celebrate();
      lastRemaining = remaining;

      if (bar.classList.contains('owl-fsb--done') !== done) {
        bar.classList.toggle('owl-fsb--done', done);
      }
      bar.classList.toggle('owl-fsb--discounted', discounted);

      const fill = bar.querySelector('[data-owl-fsb-fill]');
      if (fill) {
        const width = pct.toFixed(2) + '%';
        if (fill.style.width !== width) fill.style.width = width;
      }

      const track = bar.querySelector('[role="progressbar"]');
      if (track) track.setAttribute('aria-valuenow', String(Math.round(pct)));

      const text = bar.querySelector('[data-owl-fsb-text]');
      if (text) {
        const template = discounted
          ? bar.dataset.owlFsbMsgDiscount
          : done
            ? bar.dataset.owlFsbMsgDone
            : bar.dataset.owlFsbMsgRemaining;
        const html = (template || '').replace('{amount}', formatCop(remaining));
        if (text.dataset.owlFsbRendered !== html) {
          text.dataset.owlFsbRendered = html;
          text.innerHTML = html;
        }
      }
    });
  };

  const refresh = () => {
    if (!document.querySelector('[data-owl-fsb]')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then(applyCart)
      .catch(() => {});
  };

  // Estado inicial: si la barra ya viene "done" del servidor NO se celebra al
  // cargar; si no hay barra (carrito vacio) el carrito esta bajo el umbral.
  const bar0 = document.querySelector('[data-owl-fsb]');
  lastRemaining = bar0 && bar0.classList.contains('owl-fsb--done') ? 0 : 1;

  const refreshAfterCartUpdate = (event) => {
    if (event.promise && typeof event.promise.then === 'function') {
      event.promise.then(() => {
        refresh();
        setTimeout(refresh, 700);
      }).catch(() => {});
    } else {
      setTimeout(refresh, 600);
    }
  };

  document.addEventListener('shopify:cart:lines-update', refreshAfterCartUpdate);
  document.addEventListener('shopify:cart:discount-update', refreshAfterCartUpdate);
})();
